<table  class="table mat-elevation-z8" id="" mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="tecnologia">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-5"> Técnologia </th>
      <td mat-cell *matCellDef="let element" class="pl-5"> {{element.tecnologia}} </td>
    </ng-container> 

    <ng-container matColumnDef="tempo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Tempo em Anos </th>
      <td mat-cell *matCellDef="let element"> {{element.tempo}} </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>